// extracted by mini-css-extract-plugin
export default {"variantsContainer":"QuestionImgQuiz_variantsContainer__xGolm","blockImgQuestion":"QuestionImgQuiz_blockImgQuestion__04sXq","variants":"QuestionImgQuiz_variants__Vhqqf"};